import { useContext, useState } from "react";
import { userContext } from "./UserSetting";
import User from "../organization/add-organization/user";
import Swal from "sweetalert2";
import apiUrls from "../../ApiUrl";
import Cookies from "js-cookie";

export default function EditUser({ superAdmin }) {
    const {
        showEdit,
        setShowEdit,
        onFetch,
        setOnFetch,
        EditUserDataCheck,
        EditUserData,
        error,
        setError,
        retryCount,
        setRetryCount, errorEmail, errorUsername
    } = useContext(userContext);
    const [onHole, setOnHole] = useState(true);
    const token = Cookies.get("accessToken");

    // * Handle Function Start
    const handleModalClick = (e) => {
        e.stopPropagation();
        setOnHole(true);
    };

    const closeModal = () => {
        if (onHole !== false) {
            setShowEdit(false);
        }
        setOnHole(true);
    };

    const closeModals = () => {
        setShowEdit(false);
    };

    const handleSubmit = () => {
        let keysExist = false;
        const areAllInputsFilled = Object.values(EditUserData).every(
            (input) => input !== ""
        ); //* จำเป็นต้องกรอกข้อมูลทั้งหมด
        if (areAllInputsFilled && errorEmail === false && errorUsername === false) {
            apiUrls.setUserRequest3(EditUserDataCheck.keyName);
            apiUrls.setUserRequest4(EditUserDataCheck.userId);
            Object.keys(EditUserData).forEach((key) => {
                if (EditUserData[key] === EditUserDataCheck[key]) {

                } else {
                    if (error != "Password-Fail") {
                        keysExist = true;
                    }
                }
            });
            if (keysExist) {
                Object.keys(EditUserData).forEach((key) => {
                    if (EditUserData[key] === EditUserDataCheck[key]) {
                        delete EditUserData[key];
                    }
                });
                SubmitData();
            } else if (!keysExist && error != "Password-Fail") { setError("No Edit"); }
        } else {
            setError(true);
        }
    };
    // * Handle Function End

    function SubmitData() {
        const options = {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        };
        const bodyUser = JSON.stringify(EditUserData);
        setOnFetch(true);
        fetch(apiUrls.user_Request, { ...options, body: bodyUser })
            .then((response) => response.json())
            .then((result) => {
                if (result.status === 200 || result.status === 201) {
                    console.log(result);
                    Swal.fire({
                        icon: "success",
                        title: "Submission Successful!",
                        // text: "user has been update",
                    });
                    setOnFetch(false);
                    setRetryCount(retryCount + 1);
                    apiUrls.setUserRequest3("");
                    apiUrls.setUserRequest4("");
                    closeModals();
                } else {
                    console.log("organization error submit:", result);
                    Swal.fire({
                        icon: "error",
                        title: "Submission Failed",
                        // text: result.message,
                    });
                    apiUrls.setUserRequest3("");
                    apiUrls.setUserRequest4("");
                    setOnFetch(false);
                    closeModals();
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            })
            .finally(() => {
                setOnFetch(false);
                apiUrls.setUserRequest3("");
                apiUrls.setUserRequest4("");
            });

    }

    return (
        <>
            {showEdit && (
                <div className="overlay">
                    <div className="bodyModal" onClick={closeModal}>
                        <div
                            className="modals-organization"
                            onClick={handleModalClick}
                            onMouseDown={() => setOnHole(false)}
                            onMouseUp={() => setOnHole(false)}
                        >
                            <div className="menu-bar-addOrganization" >Edit User</div>
                            <nav className="status-sidebar-addOrganization" align="center">
                                <div className="active">User Information</div>
                                {/* <div className="">เปลี่ยนรหัสผ่าน</div> */}
                            </nav>

                            <div className="Router-addOrganization">
                                <User context={userContext} efield={true} edit={true} superAdmin={superAdmin} />
                            </div>

                            <div className="menu-bar-addOrganization">
                                <button className="btn-addOrg close" onClick={closeModals}>
                                    Close
                                </button>

                                <button
                                    className="btn-addOrg next"
                                    onClick={handleSubmit}
                                    disabled={onFetch}
                                    align="center"
                                >
                                    {onFetch ? <span className="loader2"></span> : "Submit"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
